<div class="order-detail-pulldown-wrapper">

  @if (Loading) {
  <p class="muted">Loading order details...</p>
  }

  @if (!Loading && Order) {
  <div class="order-detail-scroll">
    <div class="status-row">
      <span class="status-badge">{{ Order.StatusName }}</span>
    </div>

    <div class="detail-columns">

      <div class="detail-fields">

        <div class="detail-block">
          <h4>Order Info</h4>
          <div class="detail-row"><span>Trader</span><strong>{{ Order.TraderName }}</strong></div>
          <div class="detail-row"><span>Order Source</span><strong>{{ Order.OrderSource }}</strong></div>
          <div class="detail-row"><span>Requested Ship / Pickup Date</span><strong>{{ Order.ProposedPickupDate | date }}</strong></div>
          <div class="detail-row"><span>Warehouse</span><strong>{{ Order.WarehouseName }}</strong></div>
          <div class="detail-row"><span>Carrier / Trucker</span><strong>{{ Order.TruckerName }}</strong></div>
          <div class="detail-row"><span>Payment Method</span><strong>{{ Order.PaymentMethodName }}</strong></div>
          <div class="detail-row"><span>Payment Terms</span><strong>{{ Order.PaymentTermName }}</strong></div>
        </div>

        <div class="detail-block">
          <h4>Line Items</h4>
          @for (item of LineItems; track item.InventoryID) {
          <div class="detail-line-item">
            <span>{{ item.InventoryTypeName }}</span>
            <span>{{ item.NumberOfBags }} bags</span>
            <span>{{ item.Price | currency }}/lb</span>
          </div>
          }
          <div class="detail-total"><strong>Total Bags: {{ totalBags }}</strong></div>
        </div>

        <div class="detail-block">
          <h4>Shipping</h4>
          @for (address of ShippingAddresses; track address.OrderShippingAddressID) {
          <div class="detail-row">
            <span>{{ address.IsPrimary ? 'Primary' : 'Address' }}</span>
            <strong>{{ address.Street }}, {{ address.City }}, {{ address.State }} {{ address.ZipCode }}</strong>
          </div>
          }
          <div class="detail-row"><span>Delivery Order Instructions</span><strong>{{ Order.WarehouseInstructions ?? '—' }}</strong></div>
          <div class="detail-row"><span>Invoice Instructions</span><strong>{{ Order.InvoiceInstructions1 ?? '—' }}</strong></div>
        </div>

        <div class="detail-block">
          <h4>Handling</h4>
          <div class="detail-row"><span>Shrink Wrap</span><strong>{{ Order.ShrinkWrap ? 'Yes' : 'No' }}</strong></div>
          <div class="detail-row"><span>Slip Sheets</span><strong>{{ Order.SlipSheet ? 'Yes' : 'No' }}</strong></div>
          <div class="detail-row"><span>Palletize</span><strong>{{ Order.Palletize ? 'Yes' : 'No' }}</strong></div>
          <div class="detail-row"><span>Morning Pickup</span><strong>{{ Order.MorningPickup ? 'Yes' : 'No' }}</strong></div>
          <div class="detail-row"><span>Reweight</span><strong>{{ Order.ReweighOrder ? 'Yes' : 'No' }}</strong></div>
          <div class="detail-row"><span>Customer Pickup</span><strong>{{ Order.CustomerPickup ? 'Yes' : 'No' }}</strong></div>
        </div>

        <div class="detail-actions-footer">
          <button class="btn-bg-red" mat-flat-button type="button" [disabled]="Cancelling" (click)="cancelThisOrder()">
            Cancel Order
          </button>
        </div>

      </div>

      <div class="detail-history-panel">
        <h4>Order History</h4>
        @if (ActionHistory.length === 0) {
        <p class="muted">No history recorded.</p>
        }
        @for (entry of ActionHistory; track entry.OrderActionHistoryID) {
        <div class="history-entry">
          <span class="history-action">{{ entry.ActionType }}</span>
          <span class="history-detail">{{ entry.ActionDetail }}</span>
          <span class="history-date">{{ entry.ActionDate | date:'short' }}</span>
        </div>
        }
      </div>

    </div>
  </div>
  }

</div>
